<div>
    <h3 mat-dialog-title
        class="draggable-dialogue-header"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        Edit Form Email Templates
    </h3>

    <div class="email-icon-div">
        <mat-icon class="email-icon">email</mat-icon>
    </div>

    <div mat-dialog-content>
        <div id="email-content-p" [innerHtml]="EmailContent"></div>
    </div>

    <div mat-dialog-actions class="confirm-buttons">
        <button mat-raised-button color="primary" class="theme-primary-btn" (click)="copyMessageText()">Copy Message Text</button>
        <button mat-button color="secondary" (click)="dismiss()">Dismiss</button>
    </div>
</div>
